import moment from 'moment'
import data from '@/api/data'

const LOAD_DAY_PRODUCTION = 'LOAD_DAY_PRODUCTION'
const FETCH_PRODUCTION = 'FETCH_PRODUCTION'
const COMPARE_PRODUCTION = 'COMPARE_PRODUCTION'

export default {
  namespaced: true,
  state: {
    production: null,
    fetchDates: null,
    compareDates: null
  },
  getters: {
    productionMap (state) {
      return state.production
    },
    fetchDates (state) {
      return state.fetchDates
    },
    compareDates (state) {
      return state.compareDates
    }
  },
  mutations: {
    [LOAD_DAY_PRODUCTION] (state, data) {
      state.production = data
    },
    [FETCH_PRODUCTION] (state, payload) {
      state.fetchDates = payload
    },
    [COMPARE_PRODUCTION] (state, payload) {
      state.compareDates = payload
    }
  },
  actions: {
    loadDayProduction ({ commit }, id) {
      data.productionAndInsolation(id).then(r => {
        const production = new Map()
        r.data.forEach(val => production.set(moment(val.time).format('YYYY-MM-DD'), val.production))
        commit(LOAD_DAY_PRODUCTION, production)
      })
    }
  }
}
